module.exports = {"institutions_details":{"button_back":["Retour","Back"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Institutions/translations/translations_institutions_details.json
// module id = 731
// module chunks = 0